import { NUMBER_12, NUMBER_16, NUMBER_5, NUMBER_6 } from '~shared/constants';

export enum ListTruncation {
  maxCategoriesCount = NUMBER_5,
  desktopShowMoreCount = NUMBER_6,
  desktopShowAllCount = NUMBER_12,
  mobileShowMoreCount = NUMBER_16,
}
